import { createSlice } from '@reduxjs/toolkit';
import { MapWellWaterSystemMetrics } from '../../../types';
import { fetchMapWellWaterSystemMetricsAsync,  fetchMapWellWaterSystemMetricsAsyncBuilder } from './asyncRequests'


export interface MapWellWaterSystemsMetricsInitialState {
  data: MapWellWaterSystemMetrics[];
  loading: boolean;
  error: string;
  success: boolean;
}

const initialState: MapWellWaterSystemsMetricsInitialState = {
  data: [],
  loading: false,
  error: '',
  success: false,
}

export const MapWellWaterSystemsMetricsSlice = createSlice({
  name: 'mapWellWaterSystemMetricsSlice',
  initialState,
  reducers: {
    resetMapWellWaterSystemMetricsData: (state) => {
      state.data = initialState.data
    }
  },
  extraReducers: (builder) => {
    fetchMapWellWaterSystemMetricsAsyncBuilder(builder);
  },
})

export const MapWellWaterSystemsMetricsActions = {
  ...MapWellWaterSystemsMetricsSlice.actions,
  fetchMapWellWaterSystemMetricsAsync,
}

export const MapWellWaterSystemsMetricsReducer = MapWellWaterSystemsMetricsSlice.reducer;